import React from 'react';
import { Avatar, Box, Text } from '@chakra-ui/react';
import { getBaseUrl } from 'api';

export const InfoBlock: React.FC<{
  name: string;
  pictureId: string;
  children: React.ReactNode;
}> = ({ name, pictureId, children }) => {
  return (
    <Box display="flex" alignItems="center">
      <Avatar
        name={name}
        size="lg"
        src={`${getBaseUrl()}/review/client/attachment/file/${pictureId}/inline`}
        loading="eager"
      />
      <Box ml={4}>
        <Text color="black" textStyle="h4">
          {name}
        </Text>
        {children && (
          <Text color="grayText" textStyle="body2" mb={1}>
            {children}
          </Text>
        )}
      </Box>
    </Box>
  );
};
